import { FixedPhraseReference } from "../../../domain/document";

export interface ISelectedFixedPhraseGettable {
  getSelectedFixedPhrase(): FixedPhraseReference;
}

export function instanceOfISelectedFixedPhraseGettable(instance: any): instance is ISelectedFixedPhraseGettable {
  return !!instance
    && (instance.getSelectedFixedPhrase !== undefined);
}
